var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecyclingWaste(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M17.5,9.8l-3.2,5.6c-0.1,0.2-0.1,0.5-0.1,0.7c0.1,0.2,0.3,0.4,0.5,0.5l3.9,2.2c0.4,0.2,0.9,0.1,1.2-0.3 l1.8-3.2L18,9.2L17.5,9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M20.6,34.1c0.1-0.2,0.2-0.4,0.2-0.6V29c0-0.5-0.4-0.9-0.9-0.9h-3.7l-3.5,6.2h7.2v0.1 C20.2,34.4,20.4,34.3,20.6,34.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M26.9,25.8c-0.2-0.1-0.4,0-0.5,0.1l-3.6,4.4c-0.5,0.6-0.5,1.5,0,2.1l3.6,4.3c0.2,0.1,0.4,0.2,0.6,0.1 c0.2-0.1,0.3-0.3,0.3-0.5v-1.9h4.5c1.1,0,2.1-0.6,2.7-1.6l2.3-4.1l0.3-0.5h-9.8v-2C27.3,26,27.1,25.9,26.9,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M31.6,12.7L30,13.6l-2.3-3.8c-0.5-1-1.6-1.6-2.7-1.6h-5.3l4.9,8.5l-1.7,1c-0.2,0.1-0.3,0.3-0.2,0.5 c0,0.3,0.2,0.4,0.4,0.5l5.5,0.9c0.8,0.1,1.6-0.3,1.8-1.1l2-5.2c0-0.2,0-0.4-0.2-0.6H31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M8.3,28.7l2.4,4.1c0.1,0.2,0.2,0.4,0.4,0.5l4.9-8.5l1.6,1c0.2,0.1,0.4,0.1,0.6-0.1c0.2-0.1,0.2-0.3,0.1-0.5 l-1.9-5.3c-0.3-0.7-1.1-1.1-1.9-1L9,19.8l-0.4,0.4c0,0.2,0.1,0.4,0.3,0.6l1.6,0.9l-2.2,3.9C7.8,26.6,7.8,27.7,8.3,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M36.8,25.6l-3.2-5.7c-0.3-0.4-0.8-0.5-1.3-0.3L28.5,22c0,0-0.1,0-0.1,0.1c-0.4,0.3-0.4,0.8-0.2,1.1l1.8,3.1 h7.1C37.1,26,37,25.8,36.8,25.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecyclingWaste);
export default __webpack_public_path__ + "static/media/recycling_waste.db21e504ddcce83f5e3e5ca5db3ed7e2.svg";
export { ForwardRef as ReactComponent };